import React, { useContext, useState } from 'react';
import { AuthContextTwo } from '../../contexts/AuthProviderTwo';
import './TutorSettings.css';
import toast from 'react-hot-toast';
import LoaderSmall from '../Shared/LoderSmall/LoaderSmall';

const TutorSettings = () => {
    const { changePassword } = useContext(AuthContextTwo);

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [retypeNewPassword, setRetypeNewPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (newPassword !== retypeNewPassword) {
            toast.error('New passwords do not match.');
            return;
        }

        setLoading(true);
        try {
            await changePassword(currentPassword, newPassword);
            toast.success('Password updated successfully!');
        } catch (error) {
            toast.error(error.message || 'Failed to update password.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className='bg-green-100 h-screen'>
            <div className='w-full h-20 flex justify-start pl-5 items-center bg-gree-100 shadow-md'>
                <h2 className='text-xl text600 text-start text-green-900 font-montserrat'>Settings</h2>
            </div>
            <div className='m-10 border rounded-lg bg-white '>
                <div className='flex  items-center px-8 py-5 border-b'>
                    <h1 className='text500 font-montserrat text-xl'>Update Password</h1>
                </div>
                <div className='p-8 w-[60%]'>
                    <div>
                        <div className='text-green-900 font-montserrat text500'>Current Password</div>
                        <input
                            type='password'
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            className="input border-2 border-green-600 mt-2 active:border-green-500 h-[60px]  w-full "

                        />
                    </div>
                    <div className='mt-5'>
                        <div className='text-green-900 font-montserrat text500'>New Password</div>
                        <input
                            type='password'
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="input border-2 border-green-600 mt-2 active:border-green-500 h-[60px]  w-full"

                        />
                    </div>
                    <div>
                        <div className='text-green-900 font-montserrat text500 mt-5'>Confirm New Password</div>
                        <input
                            type='password'
                            value={retypeNewPassword}
                            onChange={(e) => setRetypeNewPassword(e.target.value)}
                            className="input border-2 border-green-600 mt-2 active:border-green-500 h-[60px]  w-full"

                        />
                    </div>
                    <button
                        className='bg-green-500 px-4 py-2 text-white font-roboto text-xl rounded-lg mt-10'
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? <LoaderSmall /> : 'Update'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TutorSettings;
